<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>类型管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row>
        <el-col>
          <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="addDialogVisible = true" class="btn1">新增</el-button>
        </el-col>
      </el-row>
      <!-- 用户类型信息表格 -->
      <el-table :data="allUserTypeList">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column label="用户类型" prop="TypeName" align="center"></el-table-column>
        <el-table-column label="用户标识" prop="TypeIdentifying" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" size="mini" @click="removeUserType(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right;"
      >
      </el-pagination>
    </el-card>

    <!-- 修改用户类型的会话框 -->
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="20%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="80px">
        <el-form-item label="用户类型" prop="TypeName" required>
          <el-input v-model="editForm.TypeName"></el-input>
        </el-form-item>
        <el-form-item label="用户标识" prop="TypeIdentifying" required>
          <el-input v-model="editForm.TypeIdentifying"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="editUserType()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加类型的会话框 -->
    <el-dialog title="修改密码" :visible.sync="addDialogVisible" width="20%" @close="addDialogClose">
      <el-form :model="addFormList" ref="addFormRef" label-width="100px">
        <el-form-item label="用户类型" prop="TypeName" required>
          <el-input v-model="addFormList.TypeName"></el-input>
        </el-form-item>
        <el-form-item label="用户标识" prop="TypeIdentifying" required>
          <el-input v-model="addFormList.TypeIdentifying"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="addDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="addUserType()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '5',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'main_user_type'
            },
            getTypeList1: {
                page: '1',
                limit: '10000',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'main_user_type'
            },
            // 用户类型信息表
            allUserTypeList: [],
            //  用户类型列表总条数
            total: 0,
            // 控制修改用户对话框的显示与隐藏
            editDialogVisible: false,
            // 控制修改用户密码对话框的显示与隐藏
            addDialogVisible: false,
            // 编辑用户信息的表单数据
            editForm: [],
            // 修改用户密码信息的表单数据
            editForm1: [],
            // 用户类型表
            userTypeList: [],
            // 新增类型信息表
            addFormList: {
                TypeName: '',
                TypeIdentifying: '',
            },
            // 重置密码用户信息列表
            resetPwdUserList: [],
        }
    },
    created () {
        this.getAllUserType()
        this.getAllUserType1()
        this.getUserType()
    },
    methods: {
        //调用接口获取所有用户类型信息
        async getAllUserType () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList })
            console.log(res.data)
            this.allUserTypeList = res.data
        },
        //调用接口获取所有用户信息
        async getAllUserType1 () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList1 })
            this.total = res.data.length
        },
        //监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            console.log('111' + newSize)
            this.getTypeList.limit = newSize
            this.getAllUserType()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            this.getTypeList.page = newPage
            this.getAllUserType()
        },
        // 调用接口删除用户类型
        async removeUserType (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该信息, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/User/DeleteUserType', params)
            console.log(res)
            if (res.code != 1) {
                return this.$message.error('删除失败！')
            } else {
                this.$message.success('删除成功！')
            }
            this.getAllUserType()
            this.getAllUserType1()
        },
        // 展示修改用户类型的对话框
        async showEditDialog (scope) {
            this.editDialogVisible = true
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.getTypeList.tableName)
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            this.editForm = res.data[0]
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        // 监听修改用户密码对话框的关闭事件
        3 () {
            this.$refs.addFormRef.resetFields()
        },
        // 调用接口修改用户信息
        async editUserType () {
            let params = new URLSearchParams();
            params.append("ID", this.editForm.ID)
            params.append("TypeName", this.editForm.TypeName)
            params.append("TypeIdentifying", this.editForm.TypeIdentifying)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/User/UpdateUserType', params)
            console.log(res)
            if (res.code != 1) {
                return this.$$message.error('接口异常，修改失败！')
            } else {
                this.$message.success('修改用户类型信息成功！')
            }
            this.editDialogVisible = false
            this.getAllUserType()
            this.getAllUserType1()
        },
        // 调用接口新增用户类型
        async addUserType () {
            let params = new URLSearchParams();
            params.append("TypeName", this.addFormList.TypeName)
            params.append("TypeIdentifying", this.addFormList.TypeIdentifying)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/User/InsertUserType', params)
            if (res.code != 1) {
                return this.$$message.error('接口异常，新增失败！')
            } else {
                this.$message.success('新增用户类型成功！')
            }
            this.getAllUserType()
            this.getAllUserType1()
            this.addDialogVisible = false
        }


    }
}
</script>

<style lang="less" scoped>
.form {
  display: flex;
}
.btn {
  margin-left: 1%;
}
.button {
  width: 130%;
}
.twoform {
  display: flex;
}
.btn1 {
  margin-bottom: 10px;
}
</style>

